import { render, staticRenderFns } from "./coding.vue?vue&type=template&id=4b21feae&scoped=true"
import script from "./coding.vue?vue&type=script&lang=js"
export * from "./coding.vue?vue&type=script&lang=js"
import style0 from "./coding.vue?vue&type=style&index=0&id=4b21feae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b21feae",
  null
  
)

export default component.exports